import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
//Images
import wavesplayer from "../img/waves.png";
import caribouwebflow from "../img/caribouwebflow.png";
import lash from "../img/lash1.png";
//Animations
import { motion } from "framer-motion";
import {
  sliderContainer,
  slider,
  pageAnimation,
  fade,
  photoAnim,
  lineAnim,
} from "../animation";
import { useScroll } from "../components/useScroll";
import ScrollTop from "../components/ScrollTop";

const OurWork = () => {
  const [element, controls] = useScroll();
  const [element2, controls2] = useScroll();
  return (
    <Work
      style={{ background: "#282828" }}
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
    >
      <motion.div variants={sliderContainer}>
        <Frame1 variants={slider}></Frame1>
        <Frame2 variants={slider}></Frame2>
        <Frame3 variants={slider}></Frame3>
        <Frame4 variants={slider}></Frame4>
      </motion.div>
     
      <Project>
        <motion.h2 variants={fade}>Second Lash Site</motion.h2>
        <motion.div variants={lineAnim} className="line"></motion.div>
        <Link to="/work/lash">
          <Hide>
            <motion.img variants={photoAnim} src={lash} alt="c" />
          </Hide>
        </Link>
      </Project>
      
      <Project><motion.h2 variants={fade}>Web Flow Portfolio</motion.h2>
        <motion.div variants={lineAnim} className="line"></motion.div>
        <Link to="/work/webflow">
          <Hide>
            <motion.img variants={photoAnim} src={caribouwebflow} alt="caribou dev page" />
          </Hide>
        </Link>
      </Project>

      <Project>
        <motion.h2 variants={fade}>React Music Player</motion.h2>
        <motion.div variants={lineAnim} className="line"></motion.div>
        <Link to="/work/wavesplayer">
          <Hide>
            <motion.img variants={photoAnim} src={wavesplayer} alt="react music player" />
          </Hide>
        </Link>
      </Project>

      <ScrollTop />
    </Work>
  );
};

const Work = styled(motion.div)`
  min-height: 100vh;
  overflow: hidden;
  padding: 5rem 10rem;
  @media (max-width: 1300px) {
    padding: 2rem 2rem;
  }
  h2 {
    padding: 1rem 0rem;
  }
`;


const Project = styled(motion.div)`
  padding-bottom: 10rem;
  color: white;
  .line {
    height: 0.5rem;
    background: #A2C0DB;
    margin-bottom: 3rem;
  }
  img {
    width: 100%;
    height: 70vh;
    object-fit: cover;
  }
`;
const Hide = styled.div`
  overflow: hidden;
`;

//Frame Animation
const Frame1 = styled(motion.div)`
  position: fixed;
  left: 0;
  top: 10%;
  width: 100%;
  height: 100vh;
  background: #DDEBF8;
  z-index: 2;
`;
const Frame2 = styled(Frame1)`
  background: #9DBAD4;
`;
const Frame3 = styled(Frame1)`
  background: #5D89B0;
`;
const Frame4 = styled(Frame1)`
  background: #1D588C;
`;

export default OurWork;
